import { Validators } from '@angular/forms';
import { FormGroup, FormControl } from '@angular/forms';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { formatDate } from '@angular/common';
import { PurchasingService } from 'src/app/modules/planyard/purchasing.service';
import { DialogActions } from './../dialogs/dialog.model';
import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CustomDateHeaderComponent} from '../custom-header/customDateHeader';
import {SnackbarComponent} from '../snackbar/snackbar.component';
import { PickDateAdapter } from './mat-date-format-config';
import { Subject, takeUntil } from 'rxjs';

export const MY_FORMATS = {
  parse: {dateInput: {month: 'short', year: 'numeric', day: 'numeric'}},
    display: {
      dateInput: 'input',
      monthYearLabel: {year: 'numeric', month: 'short'},
      dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
      monthYearA11yLabel: {year: 'numeric', month: 'long'}
  }
}
@Component({
  selector: 'app-create-season-dialog',
  templateUrl: './create-season-dialog.component.html',
  styleUrls: ['./create-season-dialog.component.scss'],
  providers: [{provide: DateAdapter, useClass: PickDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}]
})
export class CreateSeasonDialogComponent implements OnInit,OnDestroy {
  customDateHeader = CustomDateHeaderComponent;
  form: FormGroup = new FormGroup({
    seasonName: new FormControl('', [Validators.required]),
    startDate: new FormControl('', [Validators.required]),
    endDate: new FormControl('', [Validators.required]),
    percentageChange: new FormControl('', [Validators.required]),
  });
  actions: DialogActions[] = [

  ];
  days: number;
  title = 'Add Season';
  private destroy$ = new Subject<void>();

  constructor(
    private dialogRef: MatDialogRef<CreateSeasonDialogComponent>,
    private purchasingService: PurchasingService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.form.get('startDate').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(res => this.calculateDays());
    this.form.get('endDate').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(res => this.calculateDays());
    if (this.data) {
      const data = {
        ...this.data,
        startDate: formatDate(this.data.startDate, 'yyyy-MM-dd', 'en'),
        endDate: formatDate(this.data.endDate, 'yyyy-MM-dd', 'en'),
      }
      this.title = 'Edit Season';
      this.form.patchValue(data);
    }
  }

  calculateDays(): void {
    const startDate = this.form.get('startDate').value;
    const endDate = this.form.get('endDate').value;
    if (startDate && endDate) {
      this.days = (new Date(endDate).getTime() - new Date(startDate).getTime()) / (1000 * 3600 * 24);
    }
  }

  action(e) {
    if(e == 'Save'){
    const payload = {
      ...this.form.value,
      startDate: new Date(this.form.value.startDate).toISOString().replace(" ", "T") ,
      endDate: new Date(this.form.value.endDate).toISOString().replace(" ", "T"),
      seasonId: this.data?.seasonId
    }
    this.purchasingService.SaveSeason(payload).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Season saved successfully',
              action: 'Dismiss',
              type: 'success',
            },
          }
      );
      this.dialogRef.close('save');
    });
  }else{
    this.dialogRef.close();
  }
  }

  close() {
    this.dialogRef.close();
  }
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
